import React, { Component } from 'react';
import { connect } from 'react-redux'
import { USER_STATE, DRAGGABLE_WINDOWS } from '../../constants'
import { Singleton } from '../../js/Singleton';
import { SingletonSharedData } from '../../js/singletonSharedData';
import { insertWindow, removeWindow } from '../../redux/actions/A_draggable_windows_controller'
import { noAvailableLocked, callBackEsclusive } from '../../js/draggableComponents';
import { CUSTOM_AGENT_STATE } from '../../js/customElements/customAgentState';

class AgentState extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: USER_STATE.LOGED_OUT,
      state1: USER_STATE.LOGED_OUT,
      state2: USER_STATE.LOGED_OUT,
      state1Design: "stateFront " + USER_STATE.LOGED_OUT,
      state2Design: "stateBack " + USER_STATE.LOGED_OUT,
      currtentFront: true,
    };
    this.language = new Singleton();
    this.sharedData = new SingletonSharedData();
    this.states = {
      [USER_STATE.LOGED_OUT]: { image: CUSTOM_AGENT_STATE[USER_STATE.LOGED_OUT], title: this.language.getText('GUIAgentStateloggedOut') },
      [USER_STATE.LOGED_IN]: { image: CUSTOM_AGENT_STATE[USER_STATE.LOGED_IN], title: this.language.getText('GUIAgentStateloggedIn') },
      [USER_STATE.AGENT_READY]: { image: CUSTOM_AGENT_STATE[USER_STATE.AGENT_READY], title: this.language.getText('GUIAgentStateready') },
      [USER_STATE.NO_AVAILABLE]: { image: CUSTOM_AGENT_STATE[USER_STATE.NO_AVAILABLE], title: this.language.getText('GUIAgentStatenotAvailable') },
      [USER_STATE.CHATTING]: { image: CUSTOM_AGENT_STATE[USER_STATE.CHATTING], title: this.language.getText('GUIUnifiedInboxchatting') },
      [USER_STATE.CALL_OUT]: { image: CUSTOM_AGENT_STATE[USER_STATE.CALL_OUT], title: this.language.getText('GUIAgentStatecallOut') },
      [USER_STATE.DIALOG]: { image: CUSTOM_AGENT_STATE[USER_STATE.DIALOG], title: this.language.getText('GUIAgentStatedialog') },
      [USER_STATE.MANUAL_CALL]: { image: CUSTOM_AGENT_STATE[USER_STATE.MANUAL_CALL], title: this.language.getText('GUIAgentStatemanualCall') },
      [USER_STATE.WAITING_TRANSFER]: { image: CUSTOM_AGENT_STATE[USER_STATE.WAITING_TRANSFER], title: this.language.getText('GUIAgentStatewaitingTransfer') },
      [USER_STATE.ERROR]: { image: CUSTOM_AGENT_STATE[USER_STATE.ERROR], title: this.language.getText('GUIAgentStateerror') },
      [USER_STATE.CALL_TRANSFER]: { image: CUSTOM_AGENT_STATE[USER_STATE.CALL_TRANSFER], title: this.language.getText('GUIAgentStatecallTransfer') },
      [USER_STATE.RINGING]: { image: CUSTOM_AGENT_STATE[USER_STATE.RINGING], title: this.language.getText('GUIAgentStateringing') },
      [USER_STATE.WRAPUP]: { image: CUSTOM_AGENT_STATE[USER_STATE.WRAPUP], title: this.language.getText('GUIAgentStatewrapUp') },
      [USER_STATE.XFER]: { image: CUSTOM_AGENT_STATE[USER_STATE.XFER], title: this.language.getText('GUIAgentStatexfer') },
      [USER_STATE.OTHER]: { image: CUSTOM_AGENT_STATE[USER_STATE.OTHER], title: this.language.getText('GUIAgentStateother') },
      [USER_STATE.EXCLUSIVE_CALLBACK]: { image: CUSTOM_AGENT_STATE[USER_STATE.EXCLUSIVE_CALLBACK], title: this.language.getText('GUIAgentStateexclusiveCallBack') },
      [USER_STATE.READY_PREVIEW]: { image: CUSTOM_AGENT_STATE[USER_STATE.AGENT_READY], title: this.language.getText('GUIAgentStateready') },
      [USER_STATE.ASSISTED]: { image: CUSTOM_AGENT_STATE[USER_STATE.ASSISTED], title: this.language.getText('GUIAgentStateassisted') },
      [USER_STATE.DIALOG_WHATSAPP]: {image: CUSTOM_AGENT_STATE[USER_STATE.DIALOG_WHATSAPP], title: this.language.getText('GUIAgentStatedialog')},
      [USER_STATE.WHATSAPP]: {image: CUSTOM_AGENT_STATE[USER_STATE.WHATSAPP], title: 'WhatsApp'},
      [USER_STATE.AGENT_PREVIEW]: { image: CUSTOM_AGENT_STATE[USER_STATE.AGENT_PREVIEW], title: this.language.getText('GUIAgentStatepreview') },
      [USER_STATE.INACTIVE]: { image: CUSTOM_AGENT_STATE[USER_STATE.INACTIVE], title: this.language.getText('GUIAgentStateinactive') },
      [USER_STATE.DIALOG_EMAIL]: {image: CUSTOM_AGENT_STATE[USER_STATE.DIALOG_EMAIL], title: this.language.getText('GUIAgentStatedialog')}
    }; 

    this.newStateAction = {
      [USER_STATE.NO_AVAILABLE]: () => this.props.insertWindow(noAvailableLocked(null), false),
      [USER_STATE.EXCLUSIVE_CALLBACK]: () => this.props.insertWindow(callBackEsclusive(null), false),
      [USER_STATE.XFER]: () => (this.sharedData.getGeneralPermissions()[96] === '0' && this.sharedData.getOdbcExternalCall() === false  ? this.props.removeWindow(DRAGGABLE_WINDOWS.MANUAL_CALL) : null),
      [USER_STATE.DIALOG]: () => this.props.removeWindow(DRAGGABLE_WINDOWS.EXCLUSIVE_CALLBACK),
      [USER_STATE.CHATTING]: () => this.props.removeWindow(DRAGGABLE_WINDOWS.EXCLUSIVE_CALLBACK),
      [USER_STATE.CALL_OUT]: () => this.sharedData.getDataPreviewPro().dialingMode === 1 && this.props.removeWindow(DRAGGABLE_WINDOWS.MANUAL_CALL),
      [USER_STATE.READY_PREVIEW]: () => setTimeout(() => this.props.removeWindow(DRAGGABLE_WINDOWS.MANUAL_CALL), 500),
      [USER_STATE.INACTIVE]: () => setTimeout(() => this.props.removeWindow(DRAGGABLE_WINDOWS.NO_AVAILABLE), 500),


    };
    this.oldStateAction = {
      [USER_STATE.NO_AVAILABLE]: () => this.props.removeWindow(DRAGGABLE_WINDOWS.NO_AVAILABLE_LOCKED),
      [USER_STATE.EXCLUSIVE_CALLBACK]: () => this.props.removeWindow(DRAGGABLE_WINDOWS.EXCLUSIVE_CALLBACK),
      [USER_STATE.DIALOG]: () => this.props.removeWindow(DRAGGABLE_WINDOWS.TRANSFER_CALL, DRAGGABLE_WINDOWS.DTMF_TONES, DRAGGABLE_WINDOWS.ONGOING_CALL_IVR, DRAGGABLE_WINDOWS.MARK_CALL),
      [USER_STATE.CHATTING]: () => this.props.removeWindow(DRAGGABLE_WINDOWS.TRANSFER_CALL, DRAGGABLE_WINDOWS.DTMF_TONES, DRAGGABLE_WINDOWS.ONGOING_CALL_IVR, DRAGGABLE_WINDOWS.MARK_CALL),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.listenerActions) {
      if (this.oldStateAction[this.state.current]) {
        this.oldStateAction[this.state.current]();
      }
      if (this.newStateAction[nextProps.userState.currentState]) {
        this.newStateAction[nextProps.userState.currentState]();
      }
    }
    if (!this.state.currtentFront) {
      this.setState({
        current: nextProps.userState.currentState,
        state1: nextProps.userState.currentState,
        state2: this.state.current,
        state1Design: "stateFront " + nextProps.userState.currentState,
        state2Design: "stateBack " + this.state.current,
        currtentFront: true,
      });
    } else {
      this.setState({
        current: nextProps.userState.currentState,
        state1: this.state.current,
        state2: nextProps.userState.currentState,
        state1Design: "stateBack " + this.state.current,
        state2Design: "stateFront " + nextProps.userState.currentState,
        currtentFront: false,
      });
    }
  }
  componentWillUnmount() {
    this.setState({ current: USER_STATE.LOGED_OUT });
  }


  render() {
    return (
      <div className="agentStateContainer">
        <div className={this.state.state1Design}>
          <div className={"imageAgentState"}>{this.states[this.state.state1].image}</div >
          <p className={"agentStateTxt"}>{this.states[this.state.state1].title}</p>
        </div>
        <div className={this.state.state2Design}>
          <div className={"imageAgentState"}>{this.states[this.state.state2].image}</div >
          <p className={"agentStateTxt"}>{this.states[this.state.state2].title}</p>
        </div>
      </div>
    );
  }
};
function mapStateToProps(state) {
  return {
    userState: state.userState,
  }
}
function mapDispatchToProps(dispatch) {
  return ({
    insertWindow: (dragWindow, closeComponentIfOpen) => { dispatch(insertWindow(dragWindow, closeComponentIfOpen)); },
    removeWindow: (...iDdragComponents) => { dispatch(removeWindow(iDdragComponents)); },
  });
}
export default AgentState = connect(
  mapStateToProps,
  mapDispatchToProps
)(AgentState);



// WEBPACK FOOTER //
// ./src/components/workSpace/agentState.jsx